export const UI_IDS = {
  page: {
    home: 'page-home',
    booking: 'page-booking',
    coupon: 'page-coupon',
    couponDetail: 'page-coupon-detail',
    lessonRegular: 'page-lesson-regular',
    lessonReviewComplete: 'page-lesson-review-complete',
    lessonTrial: 'page-lesson-trial',
    login: 'page-login',
    myPodo: 'page-my-podo',
    noticeDetail: 'page-notice-detail',
    noticeList: 'page-notice-list',
    paymentMethods: 'page-payment-methods',
    paymentSuccess: 'page-payment-success',
    paymentType: 'page-payment-type',
    reservation: 'page-reservation',
    subscribePayment: 'page-subscribe-payment',
    subscribes: 'page-subscribes',
    subscribesTickets: 'page-subscribes-tickets',
    trialSubscribe: 'page-trial-subscribe',
    classReplay: 'page-class-replay',
    tutorExclusionManage: 'page-tutor-exclusion-manage',
    onboardingIntro: 'page-onboarding-intro',
    onboardingStart: 'page-onboarding-start',
    onboardingLanguage: 'page-onboarding-language',
    onboardingGoal: 'page-onboarding-goal',
    onboardingExperience: 'page-onboarding-experience',
    onboardingFrequency: 'page-onboarding-frequency',
    onboardingPreferredTime: 'page-onboarding-preferred-time',
    onboardingClassStyle: 'page-onboarding-class-style',
    onboardingLoading: 'page-onboarding-loading',
    onboardingResult: 'page-onboarding-result',
    onboardingBooking: 'page-onboarding-booking',
    onboardingMarketing: 'page-onboarding-marketing',
    onboardingComplete: 'page-onboarding-complete',
  },
  btn: {
    appleLogin: 'btn-apple-login',
    back: 'btn-back',
    bookLesson: 'btn-book-lesson',
    bookTutorLesson: 'btn-book-tutor-lesson',
    booking: 'btn-booking',
    bookingBack: 'btn-booking-back',
    bookingCancel: 'btn-booking-cancel',
    bookingChange: 'btn-booking-change',
    bookingConfirm: 'btn-booking-confirm',
    bookingSelectTutor: 'btn-booking-select-tutor',
    bookingSubmit: 'btn-booking-submit',
    cancel: 'btn-cancel',
    cancelBooking: 'btn-cancel-booking',
    changeBooking: 'btn-change-booking',
    changeCancel: 'btn-change-cancel',
    changeConfirm: 'btn-change-confirm',
    changeDoublePack: 'btn-change-double-pack',
    changeReservation: 'btn-change-reservation',
    checkAnswer: 'btn-check-answer',
    confirm: 'btn-confirm',
    confirmDelete: 'btn-confirm-delete',
    delete: 'btn-delete',
    dismiss: 'btn-dismiss',
    dismissPopup: 'btn-dismiss-popup',
    generateAiReport: 'btn-generate-ai-report',
    goHome: 'btn-go-home',
    goNext: 'btn-go-next',
    googleLogin: 'btn-google-login',
    goPopupCta: 'btn-go-popup-cta',
    goPreview: 'btn-go-preview',
    goSubscribes: 'btn-go-subscribes',
    goToLessons: 'btn-go-to-lessons',
    goToTickets: 'btn-go-to-tickets',
    issueCertificate: 'btn-issue-certificate',
    certificateMenu: 'btn-certificate-menu',
    certificatePlan: 'btn-certificate-plan',
    certificateIssueMonth: 'btn-certificate-issue-month',
    certificateView: 'btn-certificate-view',
    certificateDownload: 'btn-certificate-download',
    joinClass: 'btn-join-class',
    kakaoLogin: 'btn-kakao-login',
    keepSubscription: 'btn-keep-subscription',
    learningGuide: 'btn-learning-guide',
    lessonHistory: 'btn-lesson-history',
    lineLogin: 'btn-line-login',
    levelUp: 'btn-level-up',
    loginBanner: 'btn-login-banner',
    loginHelp: 'btn-login-help',
    logout: 'btn-logout',
    openApp: 'btn-open-app',
    openAppStore: 'btn-open-app-store',
    openMoreOptions: 'btn-open-more-options',
    openReviewHint: 'btn-open-review-hint',
    openSettings: 'btn-open-settings',
    otherLessons: 'btn-other-lessons',
    paymentCancel: 'btn-payment-cancel',
    paymentConfirm: 'btn-payment-confirm',
    paymentSubmit: 'btn-payment-submit',
    prestudy: 'btn-prestudy',
    pronunciationBook: 'btn-pronunciation-book',
    purchaseTicket: 'btn-purchase-ticket',
    rebookLesson: 'btn-rebook-lesson',
    registerCoupon: 'btn-register-coupon',
    registerCouponEmpty: 'btn-register-coupon-empty',
    registerPayment: 'btn-register-payment',
    registerPaymentMethod: 'btn-register-payment-method',
    replay: 'btn-replay',
    replayLeave: 'btn-replay-leave',
    replayVideo: 'btn-replay-video',
    replayVideoExport: 'btn-replay-video-export',
    replayMp3: 'btn-replay-mp3',
    revokeAccount: 'btn-revoke-account',
    scrollNext: 'btn-scroll-next',
    scrollPrev: 'btn-scroll-prev',
    searchAddress: 'btn-search-address',
    setDefault: 'btn-set-default',
    showMore: 'btn-show-more',
    sectionShowAll: 'btn-section-show-all',
    skipLevelUp: 'btn-skip-level-up',
    skipPrestudy: 'btn-skip-prestudy',
    startCharacterChat: 'btn-start-character-chat',
    startReview: 'btn-start-review',
    studyAndLesson: 'btn-study-and-lesson',
    submitChurn: 'btn-submit-churn',
    trialPaymentCancel: 'btn-trial-payment-cancel',
    trialPaymentConfirm: 'btn-trial-payment-confirm',
    trialPurchase: 'btn-trial-purchase',
    tutorProfile: 'btn-tutor-profile',
    viewAiReport: 'btn-view-ai-report',
    viewCouponDetail: 'btn-view-coupon-detail',
    viewDrawing: 'btn-view-drawing',
    productPaymentSubmit: 'btn-product-payment-submit',
    tutorConnectPurchase: 'btn-tutor-connect-purchase',
    tutorConnectSubscribeStart: 'btn-tutor-connect-subscribe-start',
    tutorConnectBook: 'btn-tutor-connect-book',
    tutorConnectBookingConfirm: 'btn-tutor-connect-booking-confirm',
    tutorConnectBuyGrant: 'btn-tutor-connect-buy-grant',
    tutorConnectBrowseBuyPass: 'btn-tutor-connect-browse-buy-pass',
    tutorConnectBrowsePassCount: 'btn-tutor-connect-browse-pass-count',
    tutorConnectFavorite: (tutorId: number) => `btn-tutor-connect-favorite-${tutorId}` as const,
    profileEditSave: 'btn-profile-edit-save',
    phoneOtpRequest: 'btn-phone-otp-request',
    phoneOtpValidate: 'btn-phone-otp-validate',
    emailOtpRequest: 'btn-email-otp-request',
    emailOtpValidate: 'btn-email-otp-validate',
    selectCharacterChatType: (type: string) => `btn-select-character-chat-type-${type.toLowerCase()}` as const,
    kakaoplusTrial: (lang: 'en' | 'jp') => `btn-kakaoplus-trial-${lang}` as const,
    noticeItem: (boardId: number) => `btn-notice-item-${boardId}` as const,
    purchase: (subscribeId: string) => `btn-purchase-${subscribeId}` as const,
    purchaseType: (type: string) => `btn-purchase-${type}` as const,
    purchaseTrial: (subscribeId: string) => `btn-purchase-trial-${subscribeId}` as const,
    selectLanguage: (lang: string) => `btn-select-language-${lang}` as const,
    ticketAction: (variant: string) => `btn-ticket-action-${variant}` as const,
    ticketsLoginBanner: 'btn-tickets-login-banner',
    paymentCouponSelect: 'btn-payment-coupon-select',
    paymentTermsAgree: 'btn-payment-terms-agree',
    npsRatingNext: 'btn-nps-rating-next',
    npsSkip: 'btn-nps-skip',
    npsReasonSubmit: 'btn-nps-reason-submit',
    npsComplete: 'btn-nps-complete',
    npsToggleBlock: 'btn-nps-toggle-block',
    blockTutor: (tutorId: number) => `btn-block-tutor-${tutorId}` as const,
    unblockTutor: (tutorId: number) => `btn-unblock-tutor-${tutorId}` as const,
    onboardingIntroNext: 'btn-onboarding-intro-next',
    onboardingIntroSubmit: 'btn-onboarding-intro-submit',
    onboardingStartNext: 'btn-onboarding-start-next',
    onboardingStepNext: 'btn-onboarding-step-next',
    onboardingStepBack: 'btn-onboarding-step-back',
    onboardingResultBook: 'btn-onboarding-result-book',
    onboardingResultSkip: 'btn-onboarding-result-skip',
    onboardingBookingBack: 'btn-onboarding-booking-back',
    onboardingBookingConfirm: 'btn-onboarding-booking-confirm',
    onboardingBookingOpenLevel: 'btn-onboarding-booking-open-level',
    onboardingBookingOpenCalendar: 'btn-onboarding-booking-open-calendar',
    onboardingBookingChangeDate: 'btn-onboarding-booking-change-date',
    onboardingBookingCardChange: 'btn-onboarding-booking-card-change',
    onboardingBookingCardPrimary: 'btn-onboarding-booking-card-primary',
    onboardingMarketingAgree: 'btn-onboarding-marketing-agree',
    onboardingMarketingSkip: 'btn-onboarding-marketing-skip',
    onboardingCompletePrestudy: 'btn-onboarding-complete-prestudy',
    onboardingCompleteHome: 'btn-onboarding-complete-home',
    lessonCancelDismiss: 'btn-lesson-cancel-dismiss',
    lessonCancelConfirm: 'btn-lesson-cancel-confirm',
    faqContactUs: 'btn-faq-contact-us',
    faqStartHolding: 'btn-faq-start-holding',
    inquiryWrite: 'btn-inquiry-write',
    inquirySubmit: 'btn-inquiry-submit',
    inquiryRefundSubmit: 'btn-inquiry-refund-submit',
    inquiryCommentSend: 'btn-inquiry-comment-send',
    inquiryClose: 'btn-inquiry-close',
    inquiryCloseCancel: 'btn-inquiry-close-cancel',
    inquiryCloseConfirm: 'btn-inquiry-close-confirm',
    postPurchaseIntroBooking: 'btn-intro-booking',
    postPurchaseSelectConfirm: 'btn-select-confirm',
    postPurchaseSelectChangeDate: 'btn-select-change-date',
    postPurchaseSelectOtherTime: 'btn-select-other-time',
    postPurchaseCompletePrestudy: 'btn-complete-prestudy',
    postPurchaseCelebrateConfirm: 'btn-celebrate-confirm',
    postPurchaseBookingRetry: 'btn-post-purchase-booking-retry',
    postPurchaseBookingBack: 'btn-post-purchase-booking-back',
    onboardingLanguageChip: (lang: 'en' | 'ja') => `chip-onboarding-language-${lang}` as const,
    onboardingGoalChip: (goal: string) => `chip-onboarding-goal-${goal}` as const,
    onboardingExperienceChip: (level: number) => `chip-onboarding-experience-${level}` as const,
    onboardingFrequencyChip: (frequency: number) => `chip-onboarding-frequency-${frequency}` as const,
    onboardingPreferredTimeChip: (value: string) => `chip-onboarding-preferred-time-${value}` as const,
    onboardingClassStyleChip: (value: string) => `chip-onboarding-class-style-${value}` as const,
  },
  section: {
    banner: 'section-banner',
    cardRegister: 'section-card-register',
    classPrepare: 'section-class-prepare',
    coupon: 'section-coupon',
    customerCenter: 'section-customer-center',
    dateSelector: 'section-date-selector',
    greeting: 'section-greeting',
    languageSelect: 'section-language-select',
    levelSelect: 'section-level-select',
    paymentAmount: 'section-payment-amount',
    paymentMethod: 'section-payment-method',
    periodSelect: 'section-period-select',
    productSelect: 'section-product-select',
    profile: 'section-profile',
    settings: 'section-settings',
    subscription: 'section-subscription',
    termsAgree: 'section-terms-agree',
    timeSlots: 'section-time-slots',
    onboardingBookingCard: 'section-onboarding-booking-card',
    reservedLessons: 'section-reserved-lessons',
  },
  text: {
    onboardingBookingDate: 'text-onboarding-booking-date',
    onboardingBookingLesson: 'text-onboarding-booking-lesson',
    onboardingBookingTutor: 'text-onboarding-booking-tutor',
  },
  list: {
    banners: 'list-banners',
    couponHistory: 'list-coupon-history',
    coupons: 'list-coupons',
    languages: 'list-languages',
    lessons: 'list-lessons',
    levels: 'list-levels',
    paymentOptions: 'list-payment-options',
    preparationCards: 'list-preparation-cards',
    products: 'list-products',
    subscribes: 'list-subscribes',
  },
  item: {
    paymentMethod: (method: string) => `item-payment-${method.toLowerCase()}` as const,
    paymentCard: 'item-payment-card',
    paymentIpad: 'item-payment-ipad',
    paymentKakaopay: 'item-payment-kakaopay',
    paymentLumpsum: 'item-payment-lumpsum',
    paymentSubscribe: 'item-payment-subscribe',
    date: (fullDate: string) => `item-date-${fullDate}` as const,
    language: (langType: string) => `item-language-${langType}` as const,
    lesson: (classCourseId: number) => `item-lesson-${classCourseId}` as const,
    lessonCard: (name: string) => `item-lesson-card-${name}` as const,
    level: (level: string) => `item-level-${level}` as const,
    product: (product: string) => `item-product-${product}` as const,
    ticket: (subscribeId: string) => `item-ticket-${subscribeId}` as const,
    time: (time: string) => `item-time-${time}` as const,
    trialLesson: (classCourseId: number) => `item-trial-lesson-${classCourseId}` as const,
    trialTicket: (subscribeId: string) => `item-trial-ticket-${subscribeId}` as const,
  },
  link: {
    customerCenter: 'link-customer-center',
    myCoupon: 'link-my-coupon',
    myPodoPlan: 'link-my-podo-plan',
    notices: 'link-notices',
    notificationSettings: 'link-notification-settings',
    paymentMethods: 'link-payment-methods',
    profileEdit: 'link-profile-edit',
  },
  tab: {
    available: 'tab-available',
    en: 'tab-en',
    history: 'tab-history',
    jp: 'tab-jp',
    language: 'tabs-language',
    content: (type: string) => `tab-content-${type}` as const,
  },
  greeting: {
    noTicket: 'greeting-no-ticket',
    noBooking: 'greeting-no-booking',
    recommendTrial: 'greeting-recommend-trial',
    withBooking: 'greeting-with-booking',
  },
  empty: {
    bookingNoTicket: 'empty-booking-no-ticket',
    bookingSchedule: 'empty-booking-schedule',
    couponHistory: 'empty-coupon-history',
    coupons: 'empty-coupons',
  },
  subtab: {
    levelAll: 'subtab-level-all',
    level: (level: string) => `subtab-level-${level}` as const,
  },
  widget: {
    classPrepare: 'widget-class-prepare',
    classReportPopup: 'popup-class-report',
  },
  popup: {
    lessonCancelNoPenalty: 'popup-lesson-cancel-no-penalty',
    lessonCancelPenalty: 'popup-lesson-cancel-penalty',
  },
  checkbox: {
    termsAll: 'checkbox-terms-all',
  },
  nav: {
    item: (key: string) => `nav-${key}` as const,
  },
  chip: {
    lang: (langType: string) => `chip-lang-${langType}` as const,
    period: (period: number) => `chip-period-${period}` as const,
  },
} as const
